import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useCouponDetail } from './hooks/use-coupon-detail';
import { CouponState, getCoupon } from '@tencent/wphk-components-wecoupon';
import { i18n } from '@/i18n';
import { getCouponBtnText } from '@tencent/wphk-components-wecoupon/components/coupon-item/business';
import { hideLoading, showLoading } from '@tencent/wphk-act-base-ui';
import { to } from '@tencent/wphk-components-common/utils/common';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { showToast } from '@tencent/wphk-components-toast';
import { CustomException } from '@tencent/ppd-base-libs';
import { goCouponDetail } from '@tencent/wphk-components-wecoupon/business/coupon';
import CashCoupon from '@tencent/wphk-components-wecoupon/components/cash-coupon/index.vue';
import CouponBtn from '@tencent/wphk-components-wecoupon/components/coupon-item/button.vue';
import InfoList from './info-list.vue';

// 查询券信息

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { couponInfo, updateCouponInfo } = useCouponDetail();

/** 券状态 */
const couponState = computed(() => couponInfo.value?.state);
/** 获取按钮文案，因为Normal状态的文案跟默认不一样，所以要重写*/
const btnText = computed(() => {
  if (couponState.value === CouponState.Normal) {
    return i18n('立即領取');
  }
  if (couponState.value === CouponState.Empty) {
    return i18n('已兌罄');
  }

  return getCouponBtnText(couponState.value!);
});

/** 提示文案 */
const tipText = computed(() => {
  let msg = '';
  switch (couponState.value) {
    case CouponState.Normal:
      msg = i18n('領取後将放入「優惠專區」-「我的優惠券」');
      break;
    case CouponState.Got:
      msg = i18n('已放入「我」-「支付與服務（或「服務」）」-「優惠專區」-「我的優惠券」');
      break;
  }

  return msg;
});
/** 是否展示"已使用"状态下的提示文案 */
const isShowUsedTip = computed(() => couponState.value === CouponState.Used);

// ----- 事件start ------
async function handleBtnClick() {
  if (!couponInfo?.value) return;
  const { state = CouponState.Empty } = couponInfo.value;
  if (state === CouponState.Normal) {
    const { spId, couponId } = couponInfo.value;
    showLoading();
    const [error, res] = await to(getCoupon(spId, couponId));
    hideLoading();

    if (error) {
      showBusinessError(i18n('領取失敗，請稍候再試'));
      throw new CustomException(error, 'DetailModuleGetCoupon', couponInfo.value);
    }
    // 领取成功提示
    showToast({
      title: i18n('領取成功'),
      duration: 1000,
    });
    // 更新couponInfo
    updateCouponInfo({
      state: CouponState.Got,
      userScid: res?.userScid,
    });
  } else if (state === CouponState.Got) {
    const { type, userScid } = couponInfo.value;
    goCouponDetail(type, {
      userScid,
      adtag: 'merchant-channel',
    });
  }
}
// ----- 事件end --------

return { __sfc: true,couponInfo, updateCouponInfo, couponState, btnText, tipText, isShowUsedTip, handleBtnClick, i18n, CashCoupon, CouponBtn, InfoList }
}

})